import React, { useEffect } from 'react';
import styled from 'styled-components';

import {Html5QrcodeScanner} from 'html5-qrcode'

import { useForm } from 'react-hook-form';

const StyledPage = styled.main`
    padding: 2rem;
    .field {
        margin: 24px 0;
    }
`;

export default  () => {
    
    useEffect(() => {
        const html5QrcodeScanner = new Html5QrcodeScanner(
            'reader',
            { fps: 10, qrbox: {width: 250, height: 250} },
            /* verbose= */ false);
    
        html5QrcodeScanner.render(
            async (decodedText, decodedResult) => {
                try{
                    console.log(`Code matched = ${decodedText}`, decodedResult);
                    html5QrcodeScanner.pause();

                    /*
                    let result=await findByQR({
                        variables:{
                            code:decodedText
                        }
                    });
                    
                    */

                    alert(decodedText);
                    //console.log('Result;',result);

                    html5QrcodeScanner.resume();
                }catch(e){
                    console.error(e)
                }
            }, (error) => {
                //console.warn(`Code scan error = ${error}`); 
            });
    },[]);


    return (
        <StyledPage>
            <h1>Test QR</h1>
            
            <br /><br /><br />
            <div id="reader" style={{width:'100%',maxWidth:'500px',margin:'auto'}}></div>
            <br /><br /><br />

        </StyledPage>
    );
};

